module.exports = __webpack_public_path__ + "media/customizations/woodforest/logo-new-6b4875484e596e239f8b95c30ed62bc4.png";